import React from "react";
import {useSelector} from "react-redux";


function Cv(props) {
    const storeCv = useSelector(state => state.Candidature.cv)
    const cv = props.cv || storeCv

    if (!cv) {
        return (
            <div style={{textAlign: "center", padding: "40px"}}>
                Caricamento CV in corso...
            </div>
        )
    }

    return(
        <div>
            <object data={cv} type="application/pdf" width="100%" height="800px">
                <embed src={cv} type="application/pdf" />
            </object>
        </div>
    )
}

export default Cv
